import { useEffect, useState } from 'react';
import { getDataWithToken, GET_FAST_TAG_ROUTES_URL } from 'Utils/api';

/**
 * Ported as-is from the old tracking screen's fastag_records handling
 * (Components/MapMarkers/index.jsx) - each record's only field the old
 * screen ever reads is toll_plaza_geocode ("lat,lng" string). Implementation
 * is expected to change once real requirements for this are decided.
 */
export const useFastTag = (tripId) => {
  const [fastTagPoints, setFastTagPoints] = useState([]);

  useEffect(() => {
    if (!tripId) return;
    getDataWithToken(GET_FAST_TAG_ROUTES_URL, { trip_id: tripId })
      .then((response) => {
        const records = (response && response.data && response.data.fastag_records) || [];
        console.log('[TripTrackingV2] fastag records stored:', records);
        // Keeps the raw record too (not just lat/lng) so a hover tooltip can
        // opportunistically show whatever other fields the backend sends
        // (toll plaza name, amount, time, etc.) once we know their names.
        const points = records
          .map((record) => {
            const [lat, lng] = (record.toll_plaza_geocode || '').split(',');
            return lat && lng ? { latitude: Number(lat), longitude: Number(lng), record } : null;
          })
          .filter(Boolean);
        setFastTagPoints(points);
      })
      .catch((error) => console.log('[TripTrackingV2] fastag error:', error));
  }, [tripId]);

  return fastTagPoints;
};
